import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";
import axiosInstanceMainUrl from "../../../utils/axiosInstanceMainUrl";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const partnerTransactionApi = createAsyncThunk(
  "partnerTransaction",
  async ({ _id, month, year }) => {
    const params = {};
    if (month) {
      params.month = month;
    }
    if (year) {
      params.year = year;
    }
    const response = await axiosInstance.get(`/getPartnerTransactions/${_id}`, {
      params,
    });
    return response.data;
  },
);
export const partnerQrApi = createAsyncThunk(
  "partnerQr",
  async ({ partnerUsername }) => {
    const response = await axiosInstanceMainUrl.post("/api/admin/partner_qr", {
      partnerUsername,
    });
    return response.data;
  },
);
export const partnerClient = createAsyncThunk(
  "ClientMfdEmpPartner",
  async ({ partnerUsername, type }) => {
    const response = await axiosInstanceMainUrl.get(
      `/api/admin/getEmpClientMfdByPartner?partnerUsername=${partnerUsername}&type=${type}`,
    );
    // console.log(response, "shubham>>>>>>><nautiyal");
    return response.data;
  },
);

/************************Employee********************/
export const partnerProposal = createAsyncThunk(
  "partnerPortal",
  async ({ partner_id }) => {
    const response = await axiosInstanceMainUrl.get(
      `/api/admin/getProposalByPartner?partner_id=${partner_id}`,
    );
    return response.data;
  },
);
/*********************sip****************** */
export const partnerSipList = createAsyncThunk(
  "partnerPortal",
  async ({ partner_id }) => {
    const response = await axiosInstanceMainUrl.get(
      `/api/admin/getSipListsByPartner?partner_id=${partner_id}`,
    );
    return response.data;
  },
);

const partnerTransactionSlice = createSlice({
  name: "partnerTransaction",
  initialState: {
    partnerTransaction: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(partnerTransactionApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(partnerTransactionApi.fulfilled, (state, action) => {
        state.partnerTransaction = action.payload;
        state.loading = false;
      })
      .addCase(partnerTransactionApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default partnerTransactionSlice.reducer;
